import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Page from "components/Page";
import { Card, CardBody, Col, Row, Button, CardHeader } from "reactstrap";

import {
  ambienteAplicacion,
  urlListarCotizadoresPermisos,
} from "../../constants/urls";
import { FetchPost } from "../../redux/actions/api";
import ImgExitoso from "assets/img/REJECTED.png";
import { resetInitResp } from "../../redux/actions/aCotizacionResponsabilidad";
import { setIsDuplicatePoliza } from "../../redux/actions/ACarritoProductos";

class CotizadoresLista extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ListadoCotiadoresPermisos: undefined,
      mostrarMsgErrorPermisos: false,
      msgError: "",
    };
    this.onClick = this.onClick.bind(this);
    this.onClickHogar = this.onClickHogar.bind(this);
    this.onClickLineaFinanciera = this.onClickLineaFinanciera.bind(this);
    this.onClickAPG = this.onClickAPG.bind(this);
    this.onClickAP = this.onClickAP.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion",
      search: "?accion=nuevo",
    });
  }
  onClickHogar(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion-hogar-datospersonales",
    });
  }

  onClickAPG(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion-accidente",
    });
  }

  onClickAP(e) {
    e.preventDefault();
    this.props.history.replace({
      pathname: "/cotizacion-accidente-personal",
    });
  }

  onClickLineaFinanciera = (params) => {
    const { idProducto } = params;
    if (idProducto <= 121) {
      this.props.history.replace({
        pathname: "/cotizacion-financiero",
        search: `?idProducto=${idProducto}`,
      });
    } else if (idProducto === 124) {
      this.props.history.push({
        pathname: "/rc-andina/cotizador",
        //ssearch: ``
      });
    } else {
      this.props.history.replace({
        pathname: "/cotizacion-responsabilidad",
        search: `?idProducto=${idProducto}`,
      });
    }
  };
  
  /*ES: Identificar Cotizador Seleccionado (Código)*/
  onSelectCotizador = (prod) => {

    // Resetear el mensaje de error de poliza duplicada
    this.props.setDuplicate(false);
    
    console.log("Select Cotizador", prod);

    var path = prod.pathname

    if(prod.parametrico){
      path = `${path}/${prod.cotizadorId}`

    }
    this.props.history.push({pathname: path,search:prod.search, state: {textoBreadcrumbs: prod.textoBreadcrumbs}});

    // Resetear el estado inicial, cuando se entre a responsabilidad
    // profesional o de instituciones
    const queryProdId = new URLSearchParams(prod.search);
    const casoUrl = queryProdId.get('idProducto');
    const pathResp = prod.pathname;
    if (pathResp === '/cotizacion-responsabilidad'){
      if(casoUrl === '122' || casoUrl === '123'){
        this.props.resetResp();
      }
    }
    
  };

  async componentDidMount() {
    //Cargar datos de los cotizadores

    let resp = await FetchPost({
      url: urlListarCotizadoresPermisos,
      param: {
        empresa: "AIGMETROPOLITANA",
        ambiente: ambienteAplicacion,
        idCliente: this.props.datosAsesor.cliCodigoCore,
      },
    });
    const { transaccion, cotizadores } = resp;
    if (transaccion) {
      this.setState({ ListadoCotiadoresPermisos: cotizadores });
    } else {
      const { errorDescripcion } = resp;
      this.setState({
        mostrarMsgErrorPermisos: true,
        msgError: errorDescripcion,
      });
    }
    console.log('resp',resp)
  }

  render() {
    const {
      ListadoCotiadoresPermisos,
      mostrarMsgErrorPermisos,
      msgError,
    } = this.state;
    return (
      <Page
        title="Cotizadores"
        breadcrumbs={[{ name: "cotizadores", active: true }]}
      >
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            {ListadoCotiadoresPermisos &&
              ListadoCotiadoresPermisos.map((cotizador) => {
                return (
                  <div>
                    <Card>
                      <CardHeader>{cotizador.titulo}</CardHeader>
                      <CardBody>
                        {cotizador.productos &&
                          cotizador.productos.map((prod) => {
                            return (
                              <div>
                                <div className="media">
                                  <Row style={{ width: "102%" }}>
                                    <Col lg={9} md={12} sm={12} xs={12}>
                                      <div className="overflow-hidden media-body">
                                        <h4 className="text-truncate media-heading">
                                          {prod.subtitulo ? prod.subtitulo : ""}
                                        </h4>
                                        <p className="text-muted descripcion-cotizadores">
                                          {prod.descripcion
                                            ? prod.descripcion
                                            : ""}
                                        </p>
                                      </div>
                                    </Col>
                                    <Col lg={3} md={12} sm={12} xs={12}>
                                      <div className="alinear-width-heigth">
                                        <Button
                                          className="btn btn-primary"
                                          onClick={() =>
                                            this.onSelectCotizador(prod)
                                          }
                                        >
                                          {" "}
                                          COTIZAR{" "}
                                        </Button>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <hr></hr>
                              </div>
                            );
                          })}
                      </CardBody>
                    </Card>
                  </div>
                );
              })}
            {mostrarMsgErrorPermisos && mostrarMsgErrorPermisos === true && (
              <Row>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="detalle-cotizacion-box"
                >
                  <Card className="flex-row">
                    <CardBody>
                      <Row>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <div style={{ padding: "1em" }}>
                            <h2 style={{ color: "#001871" }}>
                              {" "}
                              Acceso Restringido
                            </h2>
                            <br></br>
                            {msgError && (
                              <div>
                                <h2> {`${msgError}`}</h2>
                              </div>
                            )}
                            <br></br>
                          </div>
                        </Col>
                        <Col
                          lg={4}
                          md={4}
                          sm={4}
                          xs={12}
                          style={{ textAlign: "center" }}
                        >
                          <img src={ImgExitoso} width="100px"></img>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  datosAsesor: state.datosUsuarios.dataUsuario,
});
const mapDispatchToProps = (dispatch) => {
  return {
    resetResp: () => dispatch(resetInitResp()),
    setDuplicate: (param) => dispatch(setIsDuplicatePoliza(param))
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizadoresLista)
);
